var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotificationsThicki = function SvgNotificationsThicki(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Trigger Area"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m18.793 15.436-1.2-1.963v-3.414a5.6 5.6 0 1 0-11.175-.022v3.437l-1.2 1.967a1.45 1.45 0 0 0-.067 1.384 1.37 1.37 0 0 0 1.221.786h2.626a3.092 3.092 0 0 0 6.025 0h2.633a1.35 1.35 0 0 0 1.2-.775 1.46 1.46 0 0 0-.063-1.4m-6.789 2.965a1.51 1.51 0 0 1-1.312-.795h2.618a1.51 1.51 0 0 1-1.306.795m-5.266-2.394 1.158-1.894a.8.8 0 0 0 .117-.417v-3.684a4.01 4.01 0 1 1 7.977.021v3.662a.8.8 0 0 0 .117.417l1.158 1.894z",
    "data-name": "Path 10987"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationsThicki);
export default ForwardRef;